<template>
  <div class="newness">
    <!-- 模块一上传图片/视频 -->
    <template v-for="(item, index) in moduleIntro" >
      <div class="text-text" v-if="item.type===1">
        <div  class="title-text">文字信息</div>
        <div
          class="content-content-main"
        >
          <el-input
            size="medium "
            class="input-content"
            style="margin: 6px 0px 6px 0px"
            type="textarea"
            v-model="item.value"
            maxlength="500"
            show-word-limit
            placeholder="请输入不超过500个字的文字信息"
          ></el-input>
          <em
            @click.stop="handleRemoveText(index)"
            class="textStyle"
            style="cursor: pointer; margin-top: 0px"
          >
            <img src="@/assets/img/course/icon_close.png" class="picIcon" alt="" />
          </em>
        </div>
      </div>
      <div class="pictureUpload" v-if="item.type===2">
        <div  class="title-text">文字信息</div>
        <el-upload
          drag
          action="#"
          :show-file-list="false"
          :auto-upload="false"
          :on-change="
            (file, fileList) => {
              uploadFile(file, fileList, index)
            }
          "
          :multiple="true"
          accept="image/jpg,image/jpeg,image/png"
        >
          <div></div>
          <em v-show="item.value" @click.stop="handleRemovePic(index)">
            <img
              class="picStyle"
              style="
                float: right;
                position: absolute;
                margin-left: 162px;
                opacity: 0.7;
              "
              src="@/assets/img/newnesscourse/delete.png"
              alt=""
            />
          </em>
          <img v-if="item.value" :src="item.value" class="avatar" alt="" />
          <div class="picContentStyle" v-else>
            <img src="@/assets/img/course/up load img.png" alt="" />
            <div class="el-upload__text1">上传图片</div>
            <div class="el-upload__text">* 建议尺寸比例16:9，不超过4m，</div>
            <div class="el-upload__text">格式为png、jpeg或jpg</div>
          </div>
        </el-upload>
        <em
          v-show="!item.value"
          @click.stop="handleRemove1(index)"
          class="picUp"
        >
          <img src="@/assets/img/course/icon_close.png" class="picIcon" alt="" />
        </em>
        <!-- 图片上传 -->
      </div>



    <!-- 视频上传 -->

      <div class="videoUpload"  v-if="item.type===3">
        <el-upload
          drag
          action="#"
          :auto-upload="false"
          :on-change="
            (file, fileList) => {
              videohandleChange(file, fileList, index)
            }
          "
          :show-file-list="false"
        >
          <!-- 视频删除 -->
          <em
            v-show="item.value"
            @click.stop="handleRemoveVideo(index)"
          >
            <img
              class="viedeoDelete"
              src="@/assets/img/newnesscourse/delete.png"
              alt=""
            />
          </em>
          <!-- <video
            v-if="item.value"
            :src="item.value"
            class="videoUp"
          ></video> -->

          <em
            v-show="item.value"
            @click.stop="handleRemoveVideo(index)"
          >
            <img
              class="viedeoDelete-result"
              src="@/assets/img/newnesscourse/delete.png"
              alt=""
            />
          </em>
          <div v-if="item.value" class="videoUp">
            <img
              src="@/assets/img/newnesscourse/upload-video.jpg"
              style="width: 364px; height: 178px; border-radius: 3px"
              alt=""
            />
          </div>

          <div class="picContentStyle" v-else>

            <img src="@/assets/img/course/up load video.png" alt="" />
            <div class="el-upload__text1">上传视频</div>
            <div class="el-upload__text">
              不超过500M，格式为Mp4，上传需一定时间，
            </div>
            <div class="el-upload__text">请上传完成再保存本页</div>
          </div>
        </el-upload>
        <el-upload
          drag
          action="#"
          :show-file-list="false"
          :auto-upload="false"
          :on-change="
            (file, fileList) => {
              uploadFile2(file, fileList, index)
            }
          "
          style="margin-left: 20px"
          accept="image/jpg,image/jpeg,image/png"
        >
          <!-- 上传视频图片删除 -->
          <em v-show="item.pic" @click.stop="handleRemoveVideoPic(index)">
            <img
              class="videoPicDelete"
              src="@/assets/img/newnesscourse/delete.png"
              alt=""
            />
          </em>
          <img v-if="item.pic" :src="item.pic" class="avatar" alt="" />
          <!--
          <em v-show="!item.imageUrl"  @click.stop="handleRemoveVideoPic(index)">
          <img  class="videoPicDelete"
          src="@/assets/img/newnesscourse/delete.png" alt="" />
        </em> -->
          <div
            class="video-pic-style"
            v-if="
              (picFlag = true && item.value != '' && item.pic == '')
            "
          >
            <div class="style-video-pic">暂无视频封面</div>
          </div>
          <div class="picContentStyle" v-else>
            <img src="@/assets/img/course/up load img.png" alt="" />
            <div class="el-upload__text1">上传视频封面图片</div>
            <div class="el-upload__text">建议尺寸比例16:9，不超过4M，</div>
            <div class="el-upload__text">
              格式为jpg、jpeg或png；不传默认采用视频第一帧作为封面
            </div>
          </div>
        </el-upload>
        <em
          v-show="!item.pic && !item.value"
          @click.stop="handleRemove2(index)"
          style="margin-left: 5px; cursor: pointer"
        >
          <img src="@/assets/img/course/icon_close.png" class="picIcon" alt="" />
        </em>
      </div>
    </template>
    <div class="add-content">
      <div class="content-text">
        <div class="pic">
          <img src="@/assets/img/newnesscourse/add-text@2x.png" class="picIcon" alt="" />
        </div>
        <div class="text" @click="addText()">添加文本</div>
      </div>
      <div class="content-text">
        <div class="pic">
          <img src="@/assets/img/newnesscourse/add-image@2x.png" class="picIcon" alt="" />
        </div>
        <div class="text" @click="addPicture()">添加图片</div>
      </div>
      <div class="content-text" v-if="hiddenVideo">
        <div class="pic">
          <img src="@/assets/img/newnesscourse/add-video@2x.png" class="picIcon" alt="" />
        </div>
        <div class="text" @click="addVideo()">添加视频</div>
      </div>
    </div>

    <cropper
      v-if="cropperShow"
      ref="cropper"
      :pic="pic"
      @changeRul="changeRul"
    ></cropper>
    <cropper
      v-if="cropperShowT"
      ref="cropperT"
      :pic="picT"
      @changeRul="changeRulT"
    ></cropper>
  </div>
</template>
<script>
import Vue from 'vue'
import cropper from './Cropper.vue'
export default {
  props: {
    hiddenPicture: {
      type: Boolean,
      default: true,
    },
    hiddenText: {
      type: Boolean,
      default: true,
    },
    Picture: {
      type: [Array],
      default: () => [],
    },
    hiddenVideo: {
      type: Boolean,
      default: true,
    },
    videoUpload: {
      type: [Array],
      default: () => [],
    },
    Text: {
      type: [Array],
      default: () => [],
    },
    moduleIntro:{
      type: [Array],
      default: () => [],
    }
  },
  data() {
    return {
      picFlag: true,
      pic: null,
      picT: null,
      cropperShow: false,
      cropperShowT: false,
    }
  },
  mounted() {},
  destroy() {},

  methods: {
    // 触发剪切图片
    updateP(index) {
      this.cropperShow = true
      this.$nextTick(() => {
        this.$refs.cropper.index = index
      })
      // console.log(this.pic,"this.pic")
    },

    updatePT(index) {
      this.cropperShowT = true
      this.$nextTick(() => {
        this.$refs.cropperT.index = index
      })

      // console.log(this.pic,"this.pic")
    },
    // 回显
    changeRul(obj, index) {
      this.cropperShow = false
      this.moduleIntro[index].value = obj.url
    },
    changeRulT(obj, index) {
      this.cropperShowT = false
      this.moduleIntro[index].pic = obj.url
      console.log(this.moduleIntro, 'this.moduleIntro')
    },
    addText() {
      this.moduleIntro.push({type:1,value:null})
    },
    addPicture() {
      this.moduleIntro.push({type:2,value:null})
    },
    addVideo() {
      this.moduleIntro.push({type:3,value:null,pic:null,})
    },




    videohandleChange(file, fileList, index) {
      //file判断格式条件

      let fileType = file.name.replace(/.+\./, '')
      console.log(fileType, 'this.files===========')
      if (fileType != 'mp4' && fileType != 'flv' && fileType != 'avi') {
        this.$message.error('请上传正确格式视频')
        return
      }
      let files = file.raw
      let self=this
      let formData = new FormData()
      formData.append('file', file.raw)
      // 本地回显
      // this.moduleIntro[index].value = URL.createObjectURL(file.raw)
      let load = 0
      let videoLoadEnd = this.moduleIntro
      let flags = false
      let token = Vue.prototype.getStorage(Vue.prototype.GLOBAL.TOKEN)
      var xhr = new XMLHttpRequest()
      let param =
        'fileName=' +
        encodeURIComponent(files.name) +
        '&fileSize=' +
        files.size +
        '&fileType=' +
        files.type +
        '&fileLastModified=' +
        files.lastModified +
        '&type=' +
        1
      var xhrCheck = new XMLHttpRequest() //检查请求
      let baseUrl = window.SITE_CONFIG['apiBaseURL']
      let upUrl = baseUrl + '/course/fileUploadContinue?' + param
      let checkUrl = baseUrl + '/course/fileUploadCheck?' + param
      xhrCheck.open('POST', checkUrl, true)
      xhrCheck.setRequestHeader('token', token)
      xhrCheck.send() //发送检查请求
      xhrCheck.onreadystatechange = () => {
        //检查状态监听，成功后执行发送上传请求
        if (xhrCheck.status == 200 && xhrCheck.readyState == 4) {
          load = parseInt(xhrCheck.responseText, 10)
          console.log(files.name + '正在等待上传结果。。。')
          console.log(files, '文件数据')
          console.log(files.slice(load, files.size, files.type), '切片数据，，')
          xhr.open('POST', upUrl, true)
          xhr.setRequestHeader('token', token)
          xhr.send(files.slice(load, files.size, files.type)) //通过File.slice方法获得未上传过的数据信息,再上传（重点）
          // xhr.onreadystatechange = function () {
          //   if (xhr.readyState == 4 && xhr.status == 200) {
          //     let data = JSON.parse(xhr.responseText)

          //     videoLoadEnd[index].value = data.resourcesId
          //     console.log(videoLoadEnd[index].resultUrl, '使地址')
          //     if (data.status === 'error') {
          //       console.log('warning')
          //     } else if (data.status == 'success') {
          //       Vue.prototype.$message.success('上传成功')
          //       console.log('上传成功')
          //       console.log(flags)
          //     }
          //   }
          // }
          xhr.onreadystatechange = function () {
          if (xhr.readyState == 4 && xhr.status == 200) {
         let data = JSON.parse(xhr.responseText)
            setTimeout(() => {
         self.postVideoUrl(data.resourcesId,index);
        }, 1000);
}
        }
      }
    }},

    postVideoUrl(groupId,index, retryCount = 10) {
      console.log(retryCount, 'retryCount*********')
        this.$request.post(`/course/getVideoUrl?groupId=${groupId}`, {})
        .then(response => {
        if(response=='noGet' && retryCount > 0){
        setTimeout(() => {
        this.postVideoUrl(groupId,index, retryCount - 1);
        }, 1000);
        } else if(response=='noGet' && retryCount == 0) {
        Vue.prototype.$message.error('上传失败');
        } else {
        this.moduleIntro[index].value= response;
        Vue.prototype.$message.success('上传成功');
        }
        })
        .catch(error => {
        console.log(error);
        });
        },
    // 上传图片
    uploadFile(item, fileList, index) {
      let fileType = item.name.replace(/.+\./, '')
      console.log(item.size, '===================item')
      console.log(fileType, 'this.files===============================')
      if (fileType != 'png' && fileType != 'jpeg' && fileType != 'jpg') {
        this.$message.error('请上传正确格式图片')
        return
      }
      if (item.size > 4194304) {
        this.$message.error('图片大小不能超过4M')
        return
      }
      // let formData = new FormData()
      // let file = item.raw
      this.pic = item.raw
      // this.$set(this.Picture, index, URL.createObjectURL(file))
      // formData.append('file', file)
      this.updateP(index)
      console.log(this.Picture,"this.picture========")
      // this.$request
      //   .post('/course/uploadPic', formData, {
      //     Headers: {
      //       'Content-Type': 'multipart/form-data;',
      //     },
      //   })
      //   .then((res) => {
      //     this.$set(this.Picture, index, res)
      //     console.log(res, '路径图片', this.Picture)
      //   })
    },
    uploadFile2(item, fileList, index) {
      let fileType = item.name.replace(/.+\./, '')
      console.log(fileType, 'this.files===============================')
      if (fileType != 'png' && fileType != 'jpeg' && fileType != 'jpg') {
        this.$message.error('请上传正确格式图片')
        return
      }
      if (item.size > 4194304) {
        this.$message.error('图片大小不能超过4M')
        return
      }
      this.picT = item.raw
      this.updatePT(index)
      console.log(this.Picture)
      // let formData = new FormData()
      // let file = item.raw
      // this.videoUpload[index].imageUrl = URL.createObjectURL(file)
      // formData.append('file', file)
      // this.$request
      //   .post('/course/uploadPic', formData, {
      //     Headers: {
      //       'Content-Type': 'multipart/form-data;',
      //     },
      //   })
      //   .then((res) => {
      //     this.videoUpload[index].imageUrl = res
      //   })
    },
    handleRemoveText(index) {
      this.moduleIntro.splice(index, 1)
    },
    handleRemove1(index) {
      this.moduleIntro.splice(index, 1)
    },
    handleRemovePic(index) {
      console.log(this.moduleIntro[index].value,index)
      if (this.moduleIntro[index].value) {

        this.$set(this.moduleIntro[index], 'value', null)
      }
    },
    handleRemove2(index) {
      this.moduleIntro.splice(index, 1)
    },
    handleRemoveVideo(index) {
      if (this.moduleIntro[index].value) {
        this.moduleIntro[index].value = ''
      }
      if (this.moduleIntro[index].pic) {
        this.moduleIntro[index].pic = ''
      }
    },
    handleRemoveVideoPic(index) {
      this.picFlag = false
      console.log(this.picFlag, 'falsi======')
      if (this.moduleIntro[index].pic) {
        this.moduleIntro[index].pic = ''
      }
    },
    handleRemove3(index) {
      if (this.moduleIntro[index].value) {
        this.moduleIntro[index].value = ''
      } else {
        this.moduleIntro.splice(index, 1)
      }
    },

    // -----上传图片视频功能end-----
  },

  created() {
    console.log(this.Picture)
  },
  components: {
    cropper,
  },
  watch:{
    // 'cropperShow':{
    //   handler(newName,oldName){
    //     if(newName||oldName){
    //       console.log("截图弹窗控制开关变化了=============")
    //     }
    //   }
    // }
  }
}
</script>
<style lang="scss" scoped>
.picIcon{
  width: 20px;
  cursor: pointer;
}
.newness {
  display: flex;
  flex-direction: column;
  .picUp {
    float: right !important;
    margin-top: -183px !important;
    margin-right: -87px !important;
    cursor: pointer !important;
  }
  .el-upload-dragger {
    width: 250px;
    height: 116px;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    display: flex;
  }
  .videoUpload {
    margin: 5px 17px 15px 111px;

    display: flex;
  }

  .addButton {
    color: black;
    display: flex;
    margin-left: left;
    margin-left: 71px;
  }
  .addButton .el-button {
    color: black;
  }
  .el-upload__text {
    margin-top: 10px;
    font-size: 18px !important;
  }

  .content-content-main {
    width: 500px;
    margin-left: 89px;
    display: flex;
    flex-direction: row;
    column-gap: 7px;
     .el-textarea__inner {
      min-height: 164.996px !important;
      width: 500px !important;
    }

     .el-textarea .el-input__count {
      bottom: 3px;
      right: 2px;
    }

     .el-textarea .el-input--medium {
      margin: 12px 0 12px 0 !important;
    }
  }

  .pictureUpload {
    width: 294px;
    height: 134px;
    position: relative;
    margin: 6px 0px 69px 89px;
  }
  .videoUp {
    height: 100%;
    width: 100%;
  }
  .avatar {
    width: 100%;
    height: 100%;
    display: block;
    z-index: 8888;
  }

  .el-upload__text {
    margin-top: 10px;
    font-size: 12px !important;
    color: #999a9c;
  }

  .videoUpload {
    margin: 21px 9px 4px 89px;
    display: flex;
  }

  .addButton {
    .el-button:hover {
      background-color: #fff !important;
      border-color: #fff !important;
    }

    .el-button:focus {
      background-color: #fff !important;
      border-color: #fff !important;
    }
  }
}
.picContentStyle {
  padding-top: 24px;
}
 .el-upload-dragger {
  border-radius: 0px !important;
}
.add-content {
  display: flex;
  margin: 17px 3px 0px 85px;
  column-gap: 66px;
  .content-text {
    display: flex;
    column-gap: 10px;
    text-align: center;
    justify-content: center;
    align-items: center;
    .text {
      cursor: pointer;
    }
  }
}
.title-text {
  width: 57px;
  padding: 18px 0px 0 11px;
  margin: 1px 0 -20px 0;
  white-space: nowrap;
}
.viedeoDelete {
  float: right;
  position: absolute;
  margin-left: 341px;
  z-index: 999;
  opacity: 0.7;
}
.video-pic-style {
  width: 354px;
  height: 169px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  font-size: 16px;
}
.viedeoDelete-result {
  float: right;
  position: absolute;
  margin-left: 162px;
  z-index: 999;
  opacity: 0.7;
}
.videoPicDelete {
  float: right;
  position: absolute;
  margin-left: 162px;
  opacity: 0.7;
}
</style>
